class NSSMarqueeWrap extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {};
    this.els.inner = this.querySelector(`.nss-marquee-wrap__inner`);
    this.els.wrap = this.querySelector(`.nss-marquee-wrap__inner > div`);
    this.els.all = this.els.wrap.childNodes;

    this.blockList = ["STYLE", "#text"];

    this.clones = [];

    this.running = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Marquee Wrap] Connected.`);

    // setTimeout(() =>  { this.measure(); }, 500);
    // this.measure();

    const interval = setInterval(() => {
      if (this.running) clearInterval(interval);
      this.measure();
    }, 1000);
  }

  measure() {
    const widthParentDouble = this.getBoundingClientRect().width * 2;
    const widthChildren = this.sumAllElsW();
    const countChildrenRough = Math.ceil(widthParentDouble / widthChildren);
    if (isNaN(countChildrenRough)) return;
    const countChildrenParity = Math.ceil(widthParentDouble / widthChildren) % 2;
    const countModifier = 1;
    const finalCount = countChildrenRough + countChildrenParity - countModifier;

    if (this.debug) console.log(`[NSS][Marquee Wrap] widthParentDouble:`, widthParentDouble);
    if (this.debug) console.log(`[NSS][Marquee Wrap] widthChildren:`, widthChildren);
    if (this.debug) console.log(`[NSS][Marquee Wrap] countChildrenRough:`, countChildrenRough);
    if (this.debug) console.log(`[NSS][Marquee Wrap] countChildrenParity:`, countChildrenParity);
    if (this.debug) console.log(`[NSS][Marquee Wrap] countModifier:`, countModifier);
    if (this.debug) console.log(`[NSS][Marquee Wrap] finalCount:`, finalCount);

    if (this.debug) console.log(`[NSS][Marquee Wrap] this.els.all:`, this.els.all);

    for (let i = 0; i < finalCount; i++) {
      this.cloneAllEls();
    }

    this.appendClones();

    const settingDuration = this.getAttribute(`nss-animation-duration`);
    const wrapperW = this.els.inner.getBoundingClientRect().width;
    const speed = (wrapperW / 1000) * settingDuration;
    if (this.debug) console.log(`[NSS][Marquee Wrap] speed:`, speed);
    this.els.inner.style.animationDuration = `${speed}s`;

    this.running = true;
  }

  sumAllElsW() {
    let w = 0;
    this.els.all.forEach((childEl) => {
      if (this.blockList.includes(childEl.nodeName)) return;
      w += childEl.getBoundingClientRect().width;
    });
    if (window.innerWidth >= 990 && this.getAttribute(`nss-use-column-gap-d`) == "true") {
      w += this.getAttribute(`nss-column-gap-d`) * (this.els.all.length - 1);
    }
    if (window.innerWidth <= 989 && this.getAttribute(`nss-use-column-gap-m`) == "true") {
      w += this.getAttribute(`nss-column-gap-m`) * (this.els.all.length - 1);
    }
    return w;
  }

  cloneAllEls() {
    this.els.all.forEach((childEl) => {
      if (this.blockList.includes(childEl.nodeName)) return;
      const cloneEl = childEl.cloneNode(true);
      cloneEl.setAttribute(`aria-hidden`, true);
      this.clones.push(cloneEl);
    });
  }

  appendClones() {
    this.clones.forEach((cloneEl) => {
      this.els.wrap.appendChild(cloneEl);
    });
  }
}

let elementName = `nss-marquee-wrap`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSMarqueeWrap);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
